<!--
  - @FileDescription 文件断点上传，支持大文件上传、断点续传，默认按每2M大小进行分片上传
  - @Author 杨道博
  - @Date 2020.5
 * @LastEditors: 方宾菲
 * @LastEditTime: 2025-02-27 13:39:41
  使用方法：
  1.需要安装依赖
    npm install vue-simple-uploader --save
    // npm install vue-video-player --save
    npm install vue-video-player@5.0.2
  2.在main.js中：
    import uploader from 'vue-simple-uploader'
    Vue.use(uploader)
  3.将fileIconList文件夹放入static下面
  4.引入组件并注册组件：
    import fileUp from "@/components/common/YsMaxFileUploader";
  5.调用示例：
    <file-up
      formName="XX_YJYLB"     //数据库文件表名（必传），后台提供
      btnName="YLJB"          //数据库文件字段名（必传），后台提供
      :ywbh="ywbh"            //业务编号，表单的主键（必传）
      :readOnly="false"       //是否只读，不传默认false
      :wjlj="wjlj"            //文件在服务器上存放的路径，根据后台要求设置，可不传
      :xmbh="xmbh"            //项目编号，在贵州项目中用到，其他项目可不传
      typeControl=".pdf,.doc,.docx,.png"   //限制文件格式，默认不限制
      limit="3">              //限制文件个数，默认不限制
    </file-up>
-->

<template>
  <div style="padding: 4px 0">
    <uploader
      :key="uploader_key"
      :options="options"
      :fileStatusText="fileStatusText"
      class="uploader-example"
      :style="{ 'min-width': 70 * imgList.length + 170 + 'px' }"
      ref="uploader"
      :autoStart="false"
      @file-success="onFileSuccess"
      @file-error="onFileError"
      @file-added="filesAdded"
    >
      <uploader-unsupport></uploader-unsupport>
      <!--已上传文件列表显示-->
      <div
        class="img-li-box"
        v-for="(item, key) in imgList"
        :key="key"
        v-loading="item.loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <!-- 已上传列表 -->
        <img
          class="img-li-b--url"
          :src="item.url"
        />

        <!-- 放大icon -->
        <div class="img-li-b--layer">
          <i
            @click="handleFileEnlarge(item, key)"
            class="el-icon-view"
            v-if="!previewOnly"
          ></i>
          <i
            @click="handleFileDownload(item, key)"
            class="el-icon-download"
            v-if="!downloadOnly"
          ></i>
          <i
            @click="handleFileRemove(item, key)"
            class="el-icon-delete"
            v-if="!readOnly"
          ></i>
          <el-tooltip
            class="item"
            effect="light"
            :content="item.name"
            placement="top"
            :enterable="false"
          >
            <span>{{ item.name }}</span>
          </el-tooltip>
        </div>
      </div>
      <uploader-list>
        <div
          class="file-panel"
          slot-scope="props"
          :class="{ collapse: collapse }"
        >
          <ul class="file-list">
            <li
              v-for="file in props.fileList"
              :key="file.id"
            >
              <uploader-file
                :class="'file_' + file.id"
                ref="files"
                :file="file"
                :list="true"
              >
                <div
                  slot-scope="slotProps"
                  v-show="!slotProps.isComplete"
                >
                  <el-progress
                    type="circle"
                    :percentage="getProgress(slotProps.progress)"
                    :width="50"
                    :stroke-width="3"
                    style="margin-left: 4px"
                  ></el-progress>
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="file.name"
                    placement="top"
                    :enterable="false"
                  >
                    <div class="waiting-name">{{ file.name }}</div>
                  </el-tooltip>
                </div>
              </uploader-file>
            </li>
          </ul>
        </div>
      </uploader-list>
      <uploader-drop v-show="!readOnly && imgList.length < limit">
        <el-tooltip
          class="item"
          effect="light"
          :content="'支持格式：' + typeControl"
          placement="top-start"
        >
          <uploader-btn
            :single="false"
            :attrs="attrs"
          ><i class="el-icon-upload"></i></uploader-btn>
        </el-tooltip>
      </uploader-drop>
    </uploader>

    <!-- 放大弹窗 -->
    <el-dialog
      :title="dialog.file.title"
      v-if="dialog.file.visible"
      :visible.sync="dialog.file.visible"
      append-to-body
      :destroy-on-close="true"
      :close-on-click-modal="false"
      custom-class="ys-dialog file-view-dialog"
      width="66%"
      v-drag
    >
      <div
        class="fileDisplay"
        style="width: 100%; height: 100%"
        v-viewer
      >
        <iframe
          :src="dialog.file.url"
          style="height: 100%; width: 100%; border: none"
        ></iframe>
      </div>
    </el-dialog>
    <!-- 文件预览弹窗 -->
    <el-image-viewer
      v-if="imgViewer.visible"
      :on-close="() => {
        imgViewer.visible = false;
      }
        "
      :url-list="imgViewer.urlList"
      :zIndex="99999"
      :initialIndex="imgViewer.initialIndex"
    />
    <!-- 视频播放 -->
    <el-dialog
      :title="dialog.video.title"
      v-if="dialog.video.visible"
      :visible.sync="dialog.video.visible"
      append-to-body
      :destroy-on-close="true"
      :close-on-click-modal="false"
      custom-class="ys-dialog video-view-dialog"
      v-drag
    >
      <video-player
        class="video-player"
        :playsinline="true"
        :options="dialog.video.playerOptions"
      ></video-player>
    </el-dialog>
  </div>
</template>

<script>
import SparkMD5 from "spark-md5";
import { searchFileList, delFile } from "@/api/fileUpOrDownload";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: { videoPlayer, ElImageViewer },
  props: {
    upFileUrl: {
      //提取文件上传地址，因为影像图上传会调用其它地址。
      type: String,
      default: "/api/common-file/dmtgl/chunkUpload",
    },
    ywbh: String, //主键,必传
    formName: String, //表名,参考数据库对照表,必传
    btnName: String, //字段名,必传
    readOnly: {
      type: Boolean,
      default: false,
    }, //是否只读，false、true
    previewOnly: {
      type: Boolean,
      default: false,
    }, //是否只能预览，false、true
    downloadOnly: {
      type: Boolean,
      default: false,
    }, //是否只能下载，false、true
    typeControl: {
      type: String,
      default: "*",
    }, //限制文件类型'.zip,.rar,.jpg'
    wjlj: String, //文件路径
    xmbh: String, //项目编号
    limit: {
      type: Number,
      default: 10000,
    }, //数量限制
    isSearchFiles: {
      //是否一开始查询文件
      type: Boolean,
      default: true,
    }, //数量限制
    minSize: String, //文件最小限制,单位为kb
    maxSize: String, //文件最大限制,单位为kb
    fileModel: String, //文件个数model绑定
    noDelete: {
      type: Boolean,
      default: false,
    }, //不能删除
    idArray: {
      type: Array,
      default: () => {
        return [];
      },
    }, //不显示的文件id集合
  },
  model: {
    prop: "fileModel",
    event: "change",
  },
  data() {
    return {
      uploader_key: new Date().getTime(),
      options: {
        target: this.upFileUrl,
        //testChunks: false,
        chunkSize: "2048000", //分块大小,每2M分片
        fileParameterName: "file", //上传文件时文件的参数名，默认file
        maxChunkRetries: 3, //最大自动失败重试上传次数
        testChunks: true, //是否开启服务器分片校验
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: function (chunk, message) {
          let objMessage = JSON.parse(message);
          if (objMessage.result && objMessage.result.skipUpload) {
            return true;
          }
          if (!objMessage.result) return [].indexOf(chunk.offset + 1) >= 0;
          return (
            (objMessage.result.uploaded || []).indexOf(chunk.offset + 1) >= 0
          );
        },
        query: {
          //form data里的参数 根据实际需要
          // taskId:'',//文件id
          ywjlzj: "", //业务记录主键
          ywjlbm: this.formName, //业务记录表名
          ywjlzdm: this.btnName, //业务记录字段名
          wjlj: "", //文件路径
          xmbh: "",
        },
        headers: {
          // 在header中添加的验证，请根据实际业务来
          Authorization: this.$store.state.user.token,
        },
      },
      attrs: {
        accept: "",
      },
      fileStatusText: {
        success: "上传成功",
        error: "上传出错",
        uploading: "上传中",
        paused: "暂停",
        waiting: "等待上传",
      },
      panelShow: false, //上传列表的显示
      collapse: false, //列表的缩放
      curTop: undefined, //标记当前列表的位置
      curLeft: undefined, //标记当前列表的位置
      imgList: [], //已上传列表
      addCount: 0, //添加文件个数
      deleteCount: 0, //删除文件个数
      fileNumber: "", //文件个数
      interfaceUrl: "/api/common-file/file/", //接口地址
      //图片预览弹窗
      imgViewer: {
        visible: false,
        urlList: [],
        initialIndex: 0,
      },
      //文件预览、视频预览弹窗
      dialog: {
        file: {
          visible: false,
          url: "",
          title: "",
        },
        video: {
          visible: false,
          url: "",
          playerOptions: {}, //视频播放器插件
        },
      },
    };
  },
  computed: {
    //Uploader实例
    uploader() {
      return this.$refs.uploader.uploader;
    },
  },
  watch: {
    ywbh(newVal) {
      if (newVal && this.isSearchFiles) {
        this.searchFiles();
      }
    },
    fileNumber(val) {
      this.$emit("change", val);
    },
    "imgList.length"(val) {
      if (val > 0) {
        this.fileNumber = val.toString();
      } else {
        this.fileNumber = "";
      }
    },
    isSearchFiles() {
      this.searchFiles();
    },
  },
  methods: {
    /**
       文件md5值计算
       * */
    computeMD5(file) {
      const loading = this.$loading({
        lock: true,
        text: "正在读取文件信息...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let fileReader = new FileReader();
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      file.pause();

      loadNext();

      fileReader.onload = (e) => {
        spark.append(e.target.result);
        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();
        } else {
          let md5 = spark.end();
          loading.close();
          this.computeMD5Success(md5, file);
        }
      };
      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        loading.close();
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },
    computeMD5Success(md5, file) {
      file.uniqueIdentifier = md5; //把md5值作为文件的识别码
      file.resume(); //开始上传
    },
    /**
       选择文件后的回调
       * */
    filesAdded(file) {
      this.$emit("selectFilesBack", file);
      this.panelShow = true;
      this.options.query.xmbh = this.xmbh;
      this.options.query.wjlj = this.wjlj; //文件路径：页面功能/主键/文件
      this.options.query.ywjlzj = this.ywbh;

      // 判断长度限制
      if (
        parseInt(this.addCount) - parseInt(this.deleteCount) >=
        parseInt(this.limit)
      ) {
        setTimeout(() => {
          this.$message({
            type: "warning",
            message: `上传数量超出限制,限制数量为${this.limit}`,
          });
        }, 0);
        file.cancel();
        file.removeFile();
        return false;
      }
      //判断文件类型
      if (this.typeControl != "*") {
        let fileType = file.name.split(".");
        let type = fileType[fileType.length - 1];
        type = type.toLowerCase(); //转换为小写
        if (this.typeControl.indexOf(type) < 0) {
          this.$message({
            type: "warning",
            message: `文件类型不匹配,限制为${this.typeControl}`,
          });
          file.cancel();
          file.removeFile();
          return false;
        }
      }
      //判断文件最小限制
      if (this.minSize) {
        //转为kb计算
        let fileSize = Math.round(file.size / 1024);
        if (fileSize < parseInt(this.minSize)) {
          this.$message({
            type: "warning",
            message: "文件大小不匹配,最小为" + this.minSize + "kb",
          });
          file.cancel();
          file.removeFile();
          return false;
        }
      }
      //判断文件最大限制
      if (this.maxSize) {
        //转为kb计算
        let fileSize = Math.round(file.size / 1024);
        if (fileSize > parseInt(this.maxSize)) {
          this.$message({
            type: "warning",
            message: "文件大小不匹配,最大为" + this.maxSize + "kb",
          });
          file.cancel();
          file.removeFile();
          return false;
        }
      }
      this.addCount++;
      this.computeMD5(file);
    },

    /**
       文件上传成功后的回调，处理图片显示
       * */
    // eslint-disable-next-line no-unused-vars
    onFileSuccess: function (rootFile, file, response, chunk) {
      // eslint-disable-line
      let res = JSON.parse(response);

      // 服务器自定义的错误，这种错误是Uploader无法拦截的
      if (!res.respCode) {
        this.$message({ message: res.message, type: "error" });
        this.deleteCount++;
        return;
      }
      if (!res.data) {
        this.$message({ message: "文件信息获取失败！", type: "error" });
        this.deleteCount++;
        return;
      }
      if (!res.data.url) {
        this.$message({ message: "文件路径获取失败！", type: "error" });
        this.deleteCount++;
        return;
      }
      // 如果服务端返回需要合并
      if (res.data.needMerge) {
        // eslint-disable-next-line no-undef
        api
          .mergeSimpleUpload({
            // eslint-disable-line
            tempName: res.tempName,
            fileName: file.name,
            ...this.params,
          })
          // eslint-disable-next-line no-unused-vars
          .then((data) => {
            // eslint-disable-line
            // 文件合并成功
            this.$message.success("上传成功1");
          });
        // 不需要合并
      } else {
        this.$message.success("上传成功");
      }

      let fileInfo = res.data;
      let url = this.interfaceUrl + fileInfo.url;
      let previewUrl = fileInfo.previewUrl
        ? this.interfaceUrl + fileInfo.previewUrl
        : ""; //文件预览地址
      //将成功的文件id返回给父组件
      this.fileBack(fileInfo.resourceID);
      let info = {
        fileSize: file.size,
        fileName: file.name,
        name: fileInfo.title, //文件名称
        serverUrl: url, //服务器上的图片路径
        fileUrl: fileInfo.url,
        type: fileInfo.extension.substring(
          fileInfo.extension.lastIndexOf(".") + 1
        ), //文件类型，jpg、png、pdf等
        wjid: fileInfo.resourceID, //返回的文件id
        loading: false,
        btnName: this.btnName, //上传按钮名称
        previewUrl,
      };

      //处理图标问题
      let imgType = [
        "jpg",
        "jpeg",
        "png",
        "bmp",
        "avi",
        "rmvb",
        "flv",
        "mp4",
        "3gp",
        "wmv",
      ];
      //将大写文件格式统一转成小写
      fileInfo.wjlx = info.type.toLowerCase();
      if (imgType.indexOf(fileInfo.wjlx) >= 0) {
        let slt = fileInfo.thumbnailUrl; //缩略图
        if (slt) {
          info["url"] = this.interfaceUrl + slt; //缩略图路径
        } else {
          //如果没有缩略图，用其他类型图片代替
          info["url"] = "/fileIconList/otherIcon.png";
        }
      } else {
        info["url"] = this.setFileType(fileInfo.wjlx);
      }
      this.imgList.push(info);
      this.$emit("getImglist", this.imgList);
      this.$emit("successCallBack", info);
    },
    // eslint-disable-next-line no-unused-vars
    onFileError: function (rootFile, file, response, chunk) {
      // eslint-disable-line
      this.$message.error("上传文件出错：" + response);
    },

    //关闭上传列表
    close() {
      this.panelShow = false;
    },
    getProgress(val) {
      return parseInt(val * 100);
    },
    /**
       查看点击
       * */
    handleFileEnlarge(info, i) {
      let imgType = ["jpg", "jpeg", "png", "bmp", "gif"]; //图片类型
      let videoType = ["avi", "rmvb", "flv", "mp4", "3gp", "wmv"]; //视频类型
      let fileType = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf"]; //文档类型
      //将大写文件格式统一转成小写
      info.type = info.type.toLowerCase();
      if (imgType.indexOf(info.type) >= 0) {
        //图片预览
        this.imgViewer.urlList = this.imgList.map((item, index) => {
          if (imgType.indexOf(item.type) > -1) {
            if (item.wjid == info.wjid) {
              this.imgViewer.initialIndex = index;
            }
            return item.serverUrl;
          }
        });
        this.imgViewer.visible = true;
      } else if (videoType.indexOf(info.type) >= 0) {
        this.dialog.video.title = info.name;
        this.dialog.video.visible = true;
        this.dialog.video.playerOptions.sources[0].src = info.serverUrl; //视频路径
        this.dialog.video.playerOptions.poster = info.url; //封面路径
      } else if (info.previewUrl && fileType.indexOf(info.type) >= 0) {
        this.dialog.file.url = info.previewUrl;
        this.dialog.file.visible = true;
        this.dialog.file.title = info.name;
      } else {
        //其他类型的文件统一进行下载
        this.handleFileDownload(info, i);
      }
    },
    /**
     * 删除点击
     * @param file
     * @param i
     * @returns {boolean}
     */
    handleFileRemove(file, i) {
      if (!file.url) {
        return false;
      }
      this.$confirm("是否删除此文件？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //不能真正删除文件
          if (this.noDelete) {
            this.$emit("deleteD", file.wjid);
            this.imgList.forEach((item, i) => {
              if (file.wjid == item.wjid) {
                this.imgList.splice(i, 1);
              }
            });
            this.$emit("getImglist", this.imgList);
            return;
          }
          //不用再转false,因为改项已被移除
          this.imgList[i].loading = true;
          delFile({ wjids: file.wjid }).then((res) => {
            if (res && res.success) {
              //图片显示有延迟
              this.imgList.splice(i, 1);
              this.$message({ type: "success", message: "删除成功!" });
              this.deleteCount++;
              this.$emit("getImglist", this.imgList);
            }
          });
        })
        .catch(() => { });
    },
    /**
     * 下载文件
     */
    handleFileDownload(info) {
      window.open(info.serverUrl);
    },
    /**
     * 查询表单文件
     */
    searchFiles() {
      this.imgList = [];
      let params = {
        ywjlzj: this.ywbh,
        ywjlbm: this.formName,
        ywjlzdm: this.btnName,
      };
      searchFileList(params).then((res) => {
        if (res && res.success) {
          Object.values(res.data).forEach((item) => {
            //条件显示文件
            if (this.noDelete) {
              item.forEach((e, i) => {
                if (this.idArray.indexOf(e.id) == "-1") {
                  item.splice(i, 1);
                }
              });
            }
            console.log(item)
            let name = item.filename + "." + item.filetype;
            let url = this.interfaceUrl + item.url; //图片路径
            let info = {
              name: name, //文件名称
              serverUrl: url, //服务器上的图片路径
              type: item.filetype, //文件类型，jpg、png、pdf等
              wjid: item.id, //返回的文件id
              previewUrl: item.previewUrl
                ? this.interfaceUrl + item.previewUrl
                : "", //文件预览地址
            };

            //处理图标问题
            let imgType = [
              "jpg",
              "jpeg",
              "png",
              "bmp",
              "avi",
              "rmvb",
              "flv",
              "mp4",
              "3gp",
              "wmv",
            ];
            //将大写文件格式统一转成小写
            item.filetype = item.filetype.toLowerCase();
            if (imgType.indexOf(item.filetype) >= 0) {
              info["url"] = this.interfaceUrl + item.pic; //缩略图路径
            } else {
              info["url"] = this.setFileType(item.filetype);
            }
            this.imgList.push(info);
          });
          this.$emit("getImglist", this.imgList);
        }
      });
    },
    /**
     * 根据文件类型，进行图标匹配
     * @param type 类型
     * @returns {string}
     */
    setFileType(type) {
      let iconLink = "";
      if (type === "pdf") {
        iconLink = "/fileIconList/pdfIcon.png";
      } else if (type === "xlsx" || type === "xls") {
        iconLink = "/fileIconList/excelIcon.png";
      } else if (type === "docx" || type === "doc") {
        iconLink = "/fileIconList/wordIcon.png";
      } else if (type === "pptx" || type === "ppt") {
        iconLink = "/fileIconList/pptIcon.png";
      } else if (
        type === "zip" ||
        type === "rar" ||
        type === "7z" ||
        type === ".apk"
      ) {
        iconLink = "/fileIconList/rarIcon.png";
      } else if (type === "txt") {
        iconLink = "/fileIconList/txtIcon.png";
      } else if (type === "mp3" || type === "wma") {
        iconLink = "/fileIconList/mp3Icon.png";
      } else {
        iconLink = "/fileIconList/otherIcon.png";
      }

      return iconLink;
    },
    /**
     * 初始化视频播放插件
     */
    initVideoPlay() {
      this.dialog.video.playerOptions = {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等
            src: "", // 路径
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      };
    },

    /**
     * @description: 文件上传成功返回对应id
     * @return {*}
     * @author:
     */
    fileBack(id) {
      this.$emit("change", id);
    },
  },
  mounted() {
    if (this.typeControl) {
      this.attrs.accept = this.typeControl.split(",");
    }
    //初始化视频播放插件
    this.initVideoPlay();
    if (this.ywbh && this.isSearchFiles) {
      this.searchFiles();
    }
    this.fileNumber = this.fileModel;
  },
  beforeDestroy() {
    this.uploader.cancel();
  },
};
</script>

<style lang="scss">
.uploader-example {
  font-size: 12px;
  min-height: 68px;
  min-width: 68px;

  .uploader-drop {
    width: 66px;
    height: 66px;
    border-radius: 8px;
    padding: 0 !important;
    float: left;
  }

  .uploader-drop:hover {
    border-color: #409eff;
  }

  .uploader-btn {
    width: 68px;
    height: 68px;
    padding: 0;
    border: none;
    line-height: 74px;
    text-align: center;
    background-color: #fbfdff;

    .el-icon-upload {
      font-size: 28px;
      color: #8c939d;
    }

    .el-icon-upload:hover {
      color: #409eff;
    }
  }

  ::v-deep .uploader-btn:hover {
    background-color: transparent !important;
  }

  .uploader-list {
    overflow: hidden;
    float: left;

    .uploader-file {
      height: 68px;
      border: none;
      line-height: 15px;

      >div {
        width: 68px;
        height: 68px;
        padding-right: 5px;
      }
    }
  }

  .file-list li {
    float: left;
  }

  .waiting-name {
    width: 100%;
    height: 30px;
    line-height: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 0px;
  }

  // 文件列表
  .img-li-box {
    position: relative;
    display: inline-block;
    float: left;
    text-align: left;
    width: 68px;
    height: 68px;
    margin-right: 10px;
    border-radius: 4px;
    transition: all 0.3s;

    // 图片
    .img-li-b--url {
      display: block;
      width: 100%;
      height: 68px;
      margin: 0 auto;
      border-radius: 4px;
    }

    // 底部
    .img-li-b--bottom {
      margin-top: 10px;

      // 名称
      .img-li-b--name {
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 25px;
        line-height: 25px;
      }
    }

    // 删除按钮
    .img-li-b--delete {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #8492a6;
      cursor: pointer;
      font-size: 1.1em;
    }

    // 放大遮罩层
    .img-li-b--layer {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      color: #fff;
      text-align: center;
      z-index: 5;
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.4);

      // 放大按钮
      i {
        margin: 13px 3px 0 3px;
        font-size: 14px;
      }

      span {
        display: inline-block;
        height: 16px;
        line-height: 16px;
        width: 62px;
        margin: 10px 3px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .img-li-b--delete,
    .img-li-b--layer {
      opacity: 0;
      transition: all 0.3s;
    }

    // 悬浮可见删除 or 放大按钮
    &:hover {

      .img-li-b--delete,
      .img-li-b--layer {
        opacity: 1;
      }
    }

    // 上传进度
    &.img-li-b--progress {
      text-align: center;
      width: 66px;

      .el-progress {
        display: block !important;
        margin: 0 auto !important;
        width: calc(100% - 1em) !important;
        height: calc(100% - 1em) !important;

        .el-progress-circle {
          width: 100% !important;
          height: 100% !important;
        }
      }

      .waiting-name {
        width: 100%;
        height: 1em;
        line-height: 1em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.file-view-dialog {
  height: calc(100% - 100px) !important;
  margin: 50px auto !important;

  .el-dialog__body {
    padding: 0;
    width: 100%;
    height: calc(100% - 40px);
  }
}

.video-view-dialog {
  height: calc(100% - 100px) !important;
  margin: 50px auto !important;
  width: 66%;
  max-height: 610px;

  .el-dialog__body {
    padding: 0;
    width: 100%;
    box-sizing: border-box;

    .video-player {
      width: 100%;
      height: 100%;

      .vjs-tech,
      .vjs-button,
      .vjs-poster,
      :focus {
        outline: none;
      }

      .vjs-big-play-button {
        height: 1.5em;
        line-height: 1.5em;
        width: 1.5em;
        left: calc(50% - 0.75em);
        top: calc(50% - 0.75em);
        border-radius: 0.75em;

        span {
          font-size: 24px;
        }
      }

      .vjs-big-play-button:focus {
        outline: none;
      }

      .vjs-control {
        width: 3em;
      }
    }
  }
}
</style>
